<!-- Runmode:A1Q用のコンポーネント -->
<template>
  <div class="a1q">
    <PinchInQue v-show="isShowPinchIn" :pinchInText="pinchInText" :pathstep="pathstep" :pinchInShowVoice="showQestionVoice"
                :pinchInSound="pinchInSound" @pinchOut="recievePinchOut" @pinchiInAudioPlay="audioPlay" @pinchInaudioPause="audioPause()"/>
    <PinchInActStore/>
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID">

          <div class="toparea-play">
            <div class="eleAni flexcenter hide">
              <div :id="'Answer' + index" v-for="(answer, index) in answersList" class="item flexcenter hv" v-show="showSelectAnswer" :key="index"
                  @touchstart="onTouchStart(answersTextList[index], answer.sounds[0])" @touchend="onTouchEnd()" @touchmove="onTouchEnd()"
                  @mousedown="$emit('hintMouseDown', $event)" @mouseup="$emit('hintMouseUp', $event)"
                  @mousemove="$emit('hintMouseMove', $event)">
                <div v-if="isEnvironmentPc()" class="input bg-white" :class="getTextFontClassQue(answersTextList[index], productLanguage)" @click="clickAnswer(answer, index)">
                    <span v-show="showQestionText" v-html="getPopupTextElem(answersTextList[index])"></span>
                </div>
                <div v-else class="input bg-white" @click="clickAnswer(answer, index)">
                  <span :style="{ visibility: showQestionText ? 'visible' : 'hidden' }" v-html="answersTextList[index]"></span>
                </div>
                <button v-show="showQestionText && showPinchInBtn" class="icon-pinch-in" @click="clickPinchIn(answersTextList[index], answer.sounds[0])"></button>
                <button v-show="showQestionVoice" class="icon-voice" @click="audioPlay(answer.sounds[0])"></button>
              </div>
              <div v-if="isScrollIconVisible" class="icon-scroll" />
            </div>
          </div>

          <CommonAct :pathstep="pathstep" :activeType="activeType" :actChoice="false" :horizontalRow="false" :scriptSystems="scriptSystems"
                     :isShowTextsParent="isShowTextsParent" :isShowVoicesParent="isShowVoicesParent" :isActivesParent="isActivesParent"
                     :isCorrectsParent="isCorrectsParent" :isInCorrectsParent="isInCorrectsParent" :needsSwiper="true"
                     :changeActives="changeActives" :changeEndAct="changeEndAct" :changeIsCorrects="changeIsCorrects" :changeIsInCorrects="changeIsInCorrects"
                     :changeIsShowTexts="changeIsShowTexts" :changeIsShowVoices="changeIsShowVoices" @actPinchIn="recieveActPinchIn"/>
      <!-- /inner -->
      </div>
    <!-- /page-content -->
    </div>
  <!-- /a1_q01 -->
  </div>
</template>

<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import jquery from "jquery";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

// コンポーネント
import CommonAct from "./CommonAct";
import PinchInQue from "./PinchInQue";
import PinchInActStore from "./PinchInActStore";

export default {
  name: "A1Q",
  props: {
    pathstep: Object,
    productLanguage: String,
    scriptSystems: Object,
    isScrollIconVisible: Boolean
  },
  mixins: [
    common,
    runmode,
    audio
  ],
  data() {
    return {
      // 出題対象のactData
      currentData: null,
      // 解答用のactの配列
      answersList: [],
      // 回答選択欄表示フラグ
      showSelectAnswer: false,
      // 正解／不正解を判断するフラグ（storeコミット用）
      ActState: true,
      // 画像選択時のマウスカーソルの種類を判断するための配列
      cursorTypes: [],
      // 全問正解時のタイマー
      allCorrectTimer: null,
      // 適用するレイアウトクラス
      activeType: "active-type1",
      // 出題用のテキスト表示するかを判断するフラグ
      showQestionText: false,
      // 出題用の音声再生アイコンを表示するかを判断するフラグ
      showQestionVoice: false,
      // Actのテキスト表示するかを判断するBoolean配列
      isShowTextsParent: [],
      // 監視用ステータス(ShowTexts)
      changeIsShowTexts: false,
      // Actの音声再生アイコンを表示するかを判断するBoolean配列
      isShowVoicesParent: [],
      // 監視用ステータス(ShowVoices)
      changeIsShowVoices: false,
      // 監視用のステータス(EndAct)
      changeEndAct: false,
      // activeクラスを適用するかを判断するBoolean配列
      isActivesParent: [],
      // 監視用のステータス(Active)
      changeActives: false,
      // 正解かを判断するBoolean配列
      isCorrectsParent: [],
      // 監視用のステータス(Correct)
      changeIsCorrects: false,
      // 不正解かを判断するBoolean配列
      isInCorrectsParent: [],
      // 監視用のステータス(InCorrect)
      changeIsInCorrects: false,
      isSelectAnswer: [],
      // ピンチインを表示するかを判断するフラグ
      isShowPinchIn: false,
      // ピンチイン対象のテキストを設定する
      pinchInText: "",
      // 段組みアニメーション（上）を実行したかを判断するフラグ
      isUpAnimation: false,
      // 回答文の一覧
      answersTextList: [],
      // ピンチインボタン表示フラグ
      showPinchInBtn: false,
      // ピンチイン対象の音声
      pinchInSound: "",
      // タッチイベント長押しタイマー
      touchTimer: null,
      tempAnswersList: null,
      // アニメーション中かを判断するオブジェクト（アニメーション中はPromise関数が設定される
      runningCorrectAnimation: null,
      // 正解時の処理を行っているか判断する
      isCorrectsState: false
    };
  },
  components: {
    CommonAct,
    PinchInQue,
    PinchInActStore
  },
  created: function() {
    this.$store.dispatch("initPinchInAct");
    this.init();
  },
  beforeDestroy: function() {
    var i = 0;
    while (i < this.pathstep.acts.length) {
      this.pathstep.acts[i].correct = false;
      i++;
    }
  },
  methods: {
    /**
     * 初期化処理
     */
    init: function() {
      this.log("A1Q start init");

      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);

      // 出題用および各Actのテキスト／音声再生アイコンを表示するかを判定する
      this.isShowQestionText();
      this.isShowQestionVoice();
      this.initShowActText();
      this.initShowActVoice();
    },
    /**
     * 問題の出題処理
     */
    question: function() {
      this.log("A1Q start question");

      const self = this;

      this.enabledIconVoice();
      this.deleteAnswerTarget();
      this.deleteAniTarget();
      this.isSelectAnswer = [];
      this.changeIsShowVoices = false;
      this.changeIsShowTexts = false;

      this.currentData = this.getQuestion();

      // スコア表示中・全解答表示中は問題出題しない
      if (this.lessonState == storeConstants.LESSON_STATE_PAUSE || this.dispAllAnswerStatus) {
        return;
      }

      // 問題取得できない場合は、次のpathstepへ遷移する
      if (this.currentData == null) {
        this.moveDownAnimation().then(function() {
          self.changeEndAct = true;

          // 親(Runmode.Vue）に通知する
          self.allCorrectTimer = setTimeout(function() {
            self.$emit("endAct");
          }, constants.ALLCORRECT_INTERVAL);
        });
        return;
      }

      // 下段の一番最初のACTかを判定する
      this.isLowerFirstAct().then(function() {
        self.isActivesParent = [];
        self.isActivesParent[self.currentData.index] = true;
        self.changeActives = true;

        self.sliderToActiveAct(self.currentData.index).then(function() {
          if (self.isChallenge(self.currentData.act)) {
            // challengeの場合は、解答文テキスト取得し、表示する
            self.setAnswerTarget(self.currentData.index);

            if (self.tempAnswersList == null) {
              self.answersList = self.getAnswers(self.currentData.act.texts[0].basicText);
            } else {
              self.answersList = self.tempAnswersList;
              self.tempAnswersList = null;
            }

            self.showSelectAnswer = true;
            self.setAnswersTextList();
            self.questionAnimation();
          } else {
            // givenの場合は、問題音声を再生し、次の問題を取得する
            self.showSelectAnswer = false;

            self.runmodePlayAudio().then(function() {
              self.changeActives = false;
              self.setInterval(constants.QUESTION_INTERVAL).then(function() {
                self.pathstep.acts[self.currentData.index].correct = true;
                self.question();
              });
            });
          }
        });
      });
    },
    /**
     *  解答用テキスト押下処理
     */
    clickAnswer: function(answer, index) {
      this.log("A1Q start clickAnswer");

      const self = this;

      if (this.isSelectAnswer[index]) {
        return;
      }

      this.isSelectAnswer = [];
      this.isSelectAnswer[index] = true;

      // 学習済登録
      this.$emit("updateLearnedGroup");

      for (var Child of this.$children) {
        Child.audioPause();
      }

      this.sliderToActiveAct(this.currentData.index).then(function() {
        if (answer.texts[0].basicText == self.currentData.act.texts[0].basicText) {
          // 正解の場合
          var i = 0;
          while (i < self.answersList.length) {
            self.isSelectAnswer[i] = true;
            i++;
          }
          self.correctAnswer(index);
        } else {
          // 不正解の場合
          self.inCorrectAnswer(index);
        }
      });
    },
    /**
     * 正解時の処理
     */
    correctAnswer: function(index) {
      this.log("A1Q start correctAnswer");

      const self = this;

      this.isCorrectsState = true;

      this.changeActives = false;
      this.pathstep.acts[this.currentData.index].correct = true;

      // スコアを登録する
      this.setActState(this.ActState);
      this.ActState = true;

      // 正解音の再生
      this.audioCorrect();

      // 正解画像の表示
      this.isCorrectsParent = [];
      this.isInCorrectsParent = [];
      this.isCorrectsParent[this.currentData.index] = true;
      this.changeIsCorrects = true;

      // 正解時アニメーション
      this.setAniTarget(index);
      this.runningCorrectAnimation = this.correctAnimation().then(function() {
        self.setInterval(constants.INCORRECT_INTERVAL).then(function() {
          self.finishedCorrectAnimation();
        });
      });
    },
    /**
     * 不正解時の処理
     */
    inCorrectAnswer: function(index) {
      this.log("A1Q start inCorrectAnswer");

      const self = this;

      this.ActState = false;

      // 不正解音の再生
      this.audioInCorrect();
      // 不正解画像の表示
      this.isCorrectsParent = [];
      this.isInCorrectsParent = [];
      this.isInCorrectsParent[this.currentData.index] = true;
      this.changeIsInCorrects = true;

      this.setInterval(constants.INCORRECT_INTERVAL).then(function() {
        // 不正解画像を非表示に変更する
        self.enabledIconVoice();
        self.changeIsInCorrects = false;
        self.isSelectAnswer[index] = false;
      });
    },
    /**
     * 正解時アニメーション後の処理
     */
    finishedCorrectAnimation: function() {
      this.log("A1Q start finishedCorrectAnimation");

      const self = this;

      this.runningCorrectAnimation = null;
      this.changeIsCorrects = false;

      this.setShowTextsAct();
      this.setShowVoicesAct();

      //clone要素を削除
      $("#cloneAniTarget").remove();

      // スコア表示中・全解答表示中は何もしない
      if (this.lessonState == storeConstants.LESSON_STATE_PAUSE || this.dispAllAnswerStatus) {
        return;
      }

      this.runmodePlayAudio().then(function() {
        self.setInterval(constants.QUESTION_INTERVAL).then(function() {
          self.isCorrectsState = false;
          self.question();
        });
      });
    },
    /**
     * Runmode毎にActのテキストを表示するかを判定する
     */
    setShowTextsAct: function() {
      this.log("A1Q start setShowTextsAct");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1Q:
        case constants.RUNMODE_C1Q:
          this.isShowTextsParent[this.currentData.index] = true;
          this.changeIsShowTexts = true;
          break;
        case constants.RUNMODE_B1Q:
          break;
        default:
          break;
      }
    },
    /**
     * Runmode毎にActの音声再生アイコンを表示するかを判定する
     */
    setShowVoicesAct: function() {
      this.log("A1Q start setShowVoicesAct");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1Q:
        case constants.RUNMODE_B1Q:
          this.isShowVoicesParent[this.currentData.index] = true;
          this.changeIsShowVoices = true;
          break;
        case constants.RUNMODE_C1Q:
          break;
        default:
          break;
      }
    },
    /**
     * Runmode毎に音声再生処理を実行する
     */
    runmodePlayAudio: function() {
      this.log("A1Q start runmodePlayAudio");

      const self = this;

      return new Promise(function(resolve, reject) {
        switch (self.pathstep.mode) {
          case constants.RUNMODE_A1Q:
          case constants.RUNMODE_B1Q:
            self.audioPlay(self.currentData.act.sounds[0]);
            var endedEvent = function() {
              $(self.myAudio).off("ended error", endedEvent);
              resolve();
            };
            $(self.myAudio).on("ended error", endedEvent);
            break;
          case constants.RUNMODE_C1Q:
            resolve();
            break;
          default:
            break;
        }
      });
    },
    /**
     * 出題時アニメーションの移動先に#answerTargetを付与する
     */
    setAnswerTarget: function(index) {
      this.log("A1Q start setAnswerTarget");

      var answerTarget = "#Item" + index + " p";
      $(answerTarget).attr("id", "answerTarget");
    },
    /**
     * #answerTargetを削除する
     */
    deleteAnswerTarget: function() {
      this.log("A1Q start deleteAnswerTarget");

      var answerTarget = " p";
      $(answerTarget).removeAttr("id");
    },
    /**
    /* 正解時アニメーションの移動先に#aniTargetを付与する
     */
    setAniTarget: function(index) {
      this.log("A1Q start setAniTarget");

      var aniTarget = "#Answer" + index + " .input";
      $(aniTarget).attr("id", "aniTarget");
    },
    /**
     * #aniTargetを削除する
     */
    deleteAniTarget: function() {
      this.log("A1Q start deleteAniTarget");

      var aniTarget = " .input";
      $(aniTarget).removeAttr("id");
    },
    /**
    /* 出題時アニメーション
     */
    questionAnimation: function() {
      this.log("A1Q start questionAnimation");

      // 移動先の情報を取得
      let eleD = $("#answerTarget");
      let eleS1 = $(".toparea-play .eleAni");
      let eleTopArea = $(".toparea-play");

      let offsetTop = eleD.offset().top;
      let offsetLeft = eleD.offset().left;
      let eleWidth = eleD.outerWidth();
      let eleHeight = eleD.outerHeight();

      let offsetToparea = eleTopArea.offset().top;
      let eleGroupColumn = eleTopArea.offset().left;
      let brouserWidth = $(window).width();

      // 選択肢非表示解除
      eleS1.removeClass("hide");
      eleS1.addClass("on");

      // 選択肢の位置を取得
      let offsetTopD = eleS1.offset().top;
      let offsetLeftD = eleS1.offset().left;

      // 選択肢部分のスタイルを移動用に変更
      eleS1.css({
        top: offsetTop - offsetToparea,
        left: offsetLeft - eleGroupColumn,
        width: eleWidth,
        height: eleHeight,
        position: "absolute"
      });

      if (this.isEnvironmentPc()) {
        // アニメーション開始 PC
        eleS1.stop().animate({
          top: "0",
          left: brouserWidth / 2
        }, 500, function() {
          eleS1.removeClass("on");
          eleS1.css({
            width: "100%",
            position: "relative",
            left: "0"
          });
        });
      } else {
        const self = this;
        // アニメーション開始 SP
        eleS1.stop().animate({
          top: "0"
        }, 500, function() {
          eleS1.removeClass("on");
          eleS1.css("cssText", "position: relative;");
          // 表示領域自動調整
          self.autoAdjustTopArea();
          self.applyTopAreaSize();
          // スクロールアイコン表示
          self.$emit("showScrollIcon", document.getElementsByClassName("eleAni")[0]);
        });
      }
    },
    /**
    /* 正解時アニメーション
    */
    correctAnimation: function() {
      this.log("A1Q start correctAnimation");

      const self = this;

      let eleS = $("#aniTarget");
      let eleD = $("#answerTarget");
      let eleS1 = $(".toparea-play .eleAni");
      let iconVoice = $("#aniTarget").next(".icon-voice");

      // 音声アイコンも非表示に
      iconVoice.addClass("hide");

      // 移動元の情報を取得
      let offsetTopeleS = eleS.offset().top;
      let offsetLefteleS = eleS.offset().left;

      // 移動先の情報を取得
      let offsetTop = eleD.offset().top;
      let offsetLeft = eleD.offset().left;
      let eleWidth = eleD.outerWidth();
      let eleHeight = eleD.outerHeight();

      let headerElem = $(".header");
      let animateTopClone = offsetTopeleS - headerElem.outerHeight();
      let animateTop = offsetTop - headerElem.outerHeight();

      return new Promise(function(resolve, reject) {
        // 移動元の要素をclone
        if (!$("#cloneAniTarget").length) {
          let cloneEleS = $("#aniTarget").clone();
          cloneEleS.attr("id", "cloneAniTarget");
          cloneEleS.prependTo(".page-content");
          eleS1.addClass("hide");
          cloneEleS.addClass("hide");
          cloneEleS.css({
            top: animateTopClone,
            left: offsetLefteleS,
            position: "absolute",
            zIndex: 9
          });

          if (self.isEnvironmentPc()) {
            // 文字切れしないようにするため、出題部分のfontクラスをActのフォントクラスに変更
            let eleSfont = self.getTargetFontClass(eleS);
            let eleDfont = self.getTargetFontClass(eleD);
            cloneEleS.removeClass(eleSfont).addClass(eleDfont);

            // 移動animate実行
            cloneEleS.stop().animate({
              top: animateTop,
              left: offsetLeft,
              width: eleWidth,
              height: eleHeight,
              zIndex: 9
            }, 500, function() {
              iconVoice.addClass("hide");
              resolve();
            });
          } else {
            // 移動animate実行
            cloneEleS.stop().animate({
              top: animateTop,
              left: offsetLeft,
              width: eleWidth,
              height: eleHeight,
              zIndex: 9
            }, 500, function() {
              // テキストが収まるように自動調整
              cloneEleS.textfill({
                minFontPixels: constants.AUTO_ADJUST_FONT_SIZE[self.textSize].min,
                maxFontPixels: self.cardAreaFontSize[self.displayMode],
                allowOverflow: true
              });
              iconVoice.addClass("hide");
              resolve();
            });
          }
        }
      });
    },
    /**
     * 下段の一番最初のACTかを判定する
     */
    isLowerFirstAct: function() {
      this.log("A1Q start isLowerFirstAct");

      const self = this;

      return new Promise(function(resolve, reject) {
        // スマホの場合は処理終了
        if (!self.isEnvironmentPc()) {
          resolve();
          return;
        }

        var layoutObj = self.getLayoutObject(self.pathstep.layoutID);

        // １段表示レイアウトの場合は処理終了
        if (layoutObj.actNums.length == 1) {
          resolve();
          return;
        }

        var i = 0;
        var upperActCount = 0;
        while (i < layoutObj.actNums[0].length) {
          upperActCount += layoutObj.actNums[0][i];
          i++;
        }

        if (upperActCount == self.currentData.index) {
          self.moveUpAnimation().then(function() {
            self.isUpAnimation = true;
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    /**
     * 段組みアニメーション（上）
     * 上段のACTを上方向に移動する
     */
    moveUpAnimation: function() {
      this.log("A1Q start moveUpAnimation");

      const self = this;

      return new Promise(function(resolve, reject) {
        // 既にアニメーション済みの場合は、処理終了
        if (self.isUpAnimation) {
          resolve();
          return;
        }

        var group1 = $("#group1");
        var group2 = $("#group2");
        var topArea = $(".toparea-play");
        var group1Height = group1.height();
        var topAreaOffset = topArea.offset().top;
        var topAreaHeight = topArea.height();
        var topAreaOffsetBottom = topAreaHeight + topAreaOffset;
        var group1Offset = group1.offset().top;
        var group2Offset = group2.offset().top;
        var group1Marginbottom = group1.find(".card-inner").css("margin-bottom");
        var marginBottom = group1Marginbottom.replace("px", "");
        var transPositionGroup1 = group1Offset - topAreaOffsetBottom + topAreaHeight;
        var betweenGroup = group2Offset - (topAreaOffset + group1Height);
        var transTopareaMargin = (betweenGroup - 70) / 2;
        var transToparea = topAreaOffset + group1Height - topAreaOffset + transTopareaMargin - parseInt(marginBottom);

        group1.css({
          transform: "translateY(-" + transPositionGroup1 + "px)"
        }).on("transitionend", function() {
          topArea.css({
            transform: "translateY(" + transToparea + "px)"
          }).on("transitionend", function() {
            resolve();
          });
        });
      });
    },
    /**
     * 段組みアニメーション（下）
     * 上段のACTを元の位置に移動する
     */
    moveDownAnimation: function() {
      this.log("A1Q start moveDownAnimation");

      const self = this;

      return new Promise(function(resolve, reject) {
        if (self.isUpAnimation) {
          var group1 = $("#group1");
          group1.css({ transform: "translateY(0px)" });
          resolve();
        } else {
          resolve();
        }
      });
    },

    /**
     * 全解答表示時の処理
     */
    showAllAnswer: function() {
      this.log("A1Q start showAllAnswer");

      this.showSelectAnswer = false;
    },
    /**
     * 全解答解除時の処理
     */
    hideAllAnswer: function() {
      this.log("A1Q start hideAllAnswer");

      this.showSelectAnswer = true;
    },
    /**
     * 出題用のテキストを表示するかを判定する
     */
    isShowQestionText: function() {
      this.log("A1Q start isShowQestionText");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1Q:
        case constants.RUNMODE_C1Q:
          this.showQestionText = true;
          break;
        case constants.RUNMODE_B1Q:
          this.showQestionText = false;
          break;
        default:
          break;
      }
    },
    /**
     * 出題用の音声再生アイコンを表示するかを判定する
     */
    isShowQestionVoice: function() {
      this.log("A1Q start isShowQestionVoice");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1Q:
        case constants.RUNMODE_B1Q:
          this.showQestionVoice = true;
          break;
        case constants.RUNMODE_C1Q:
          this.showQestionVoice = false;
          break;
        default:
          break;
      }
    },
    /**
     * 初期表示時に各Actのテキストを表示するかを判定する
     */
    initShowActText: function() {
      this.log("A1Q start initShowActText");

      var i = 0;
      while (i < this.pathstep.acts.length) {
        switch (this.pathstep.mode) {
          case constants.RUNMODE_A1Q:
          case constants.RUNMODE_C1Q:
            if (this.isChallenge(this.pathstep.acts[i])) {
              this.isShowTextsParent[i] = false;
            } else {
              this.isShowTextsParent[i] = true;
            }
            break;

          case constants.RUNMODE_B1Q:
            this.isShowTextsParent[i] = false;
            break;
          default:
            break;
        }
        i++;
      }
    },
    /**
     * 初期表示時に各Actの音声再生アイコンを表示するかを判定する
     */
    initShowActVoice: function() {
      this.log("A1Q start initShowActVoice");

      var i = 0;
      while (i < this.pathstep.acts.length) {
        switch (this.pathstep.mode) {
          case constants.RUNMODE_A1Q:
          case constants.RUNMODE_B1Q:
            if (this.isChallenge(this.pathstep.acts[i])) {
              this.isShowVoicesParent[i] = false;
            } else {
              this.isShowVoicesParent[i] = true;
            }
            break;

          case constants.RUNMODE_C1Q:
            this.isShowVoicesParent[i] = false;
            break;
          default:
            break;
        }
        i++;
      }
    },
    /**
     * ピンチインボタン押下時の処理
     */
    clickPinchIn: function(text, sound) {
      this.log("A1Q start clickPinchIn");

      this.isShowPinchIn = true;
      this.pinchInText = text;
      this.pinchInSound = sound;

      this.log("A1Q clickPinchIn: set lessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
    },
    /**
     * ピンチアウト押下通知を受け取る
     */
    recievePinchOut: function() {
      this.log("A1Q start recievePinchOut");

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("A1Q recievePinchOut: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    /**
     * 回答文の一覧設定
     * @returns {undefined}
     */
    setAnswersTextList: function() {
      if (this.answersList) {
        // 回答文一覧取得
        this.answersTextList = this.getLanguageBasicTextList(this.answersList, this.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
      }
    },
    /**
     * 長押しイベント開始
     * @param String text 拡大表示するテキスト
     * @param String sound 音声ファイル
     */
    onTouchStart: function(text, sound) {
      var self = this;
      if (!this.showQestionText) {
        return;
      }
      this.touchTimer = setTimeout(function() {
        self.clickPinchIn(text, sound);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      clearTimeout(this.touchTimer);
    },
    /**
     * Actの拡大表示通知を受け取る
     */
    recieveActPinchIn: function() {
      this.tempAnswersList = this.answersList;
    },
    /**
     * 出題文領域自動サイズ調整処理
     */
    autoAdjustTopArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // 出題文領域のフォントサイズを求める
      const MAX_AUTO_ADJUST_FONT_SIZE = constants.AUTO_ADJUST_FONT_SIZE[this.textSize].max;
      this.topAreaFontSize = {};
      let topAreaItems = $(".toparea-play > .eleAni > .item");
      for (let i = 0; i < topAreaItems.length; i++) {
        // 一時的にテキスト非表示
        let topAreaInput = $(topAreaItems.get(i)).children(".input");
        let topAreaText = topAreaInput.children("span");
        topAreaText.css("visibility", "hidden");

        let basicTexts = this.getAllDisplayModeTexts(this.answersList[i], this.productLanguage, this.scriptType, this.scriptSystems.default);
        for (let displayMode in basicTexts) {
          for (let basicText of basicTexts[displayMode]) {
            // レイアウト調整
            topAreaInput.children("span").css({ fontSize: MAX_AUTO_ADJUST_FONT_SIZE });
            topAreaInput.css("cssText", "height: auto;");
            topAreaText.html(basicText);
            // フォントサイズを確定させる
            let topAreaFontSize = this.topAreaFontSize[displayMode] ? this.topAreaFontSize[displayMode] : MAX_AUTO_ADJUST_FONT_SIZE;
            let adjustedFontSize = this.getAutoAdjustFontSize(topAreaInput, topAreaText, topAreaFontSize);
            this.topAreaFontSize[displayMode] = adjustedFontSize;
          }
        }

        // デフォルト表示に戻す
        topAreaText.html(this.answersTextList[i]);
        topAreaText.css("visibility", this.showQestionText ? "visible" : "hidden");
      }
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > .swiper-container:first > .swiper-wrapper:first > .item:first").clone();
        clones.textArea = clones.card.children("div").children("p");
        clones.textArea.empty();
        clones.textArea.append("<span/>");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > .swiper-container:first > .swiper-wrapper:first");
      };

      // 対象テキストを取得
      let targetTexts = this.getAllBasicTexts(this.pathstep.acts, this.productLanguage, this.scriptType, this.scriptSystems.default, false);

      // サイズを確定させる
      this.fixCardAreaSize(targetTexts, cloneCard, clones);
    },
    /**
     * 出題文領域サイズ適用
     */
    applyTopAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedFontSize = this.topAreaFontSize[this.displayMode];
      // 確定したフォントサイズを設定
      const topAreaItems = $(".toparea-play > .eleAni > .item");
      topAreaItems.children(".input").children("span").css({ fontSize: fixedFontSize });
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedHeight = this.cardAreaHeight[this.displayMode];
      let fixedFontSize = this.cardAreaFontSize[this.displayMode];
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .swiper-container > .swiper-wrapper > .item > div > p");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
      // 出題文表示領域の高さを調整する
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      $(".toparea-play").css({
        height: rootHeight - headerHeight - footerHeight - cardsContainerHeight
      });
    },
    /**
     * 自動調整サイズ適用
     */
    applyAutoAdjustSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      this.applyTopAreaSize();
      this.applyCardAreaSize();
    }
  },
  mounted: function() {

    if (this.isMobile()) {
      // スマホの場合は、sliderを初期化
      this.sliderInit();
      // 自動調整初期処理
      this.initAutoAdjust([".page-content"], [".page-content"]);
    }

    if (this.lessonState == storeConstants.LESSON_STATE_START) {
      // 問題文の取得
      this.question();
    }
  },
  watch: {
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A1Q watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus) {
        this.showAllAnswer();
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else {
        this.hideAllAnswer();
        this.question();
      }
    },
    /**
     * スコア表示状態を監視する
     */
    lessonState: function(newstatus) {
      this.log("A1Q watch lessonState");

      if (this.lessonState == storeConstants.LESSON_STATE_START) {
        // 問題文の取得
        this.question();
      } else if (this.lessonState == storeConstants.LESSON_STATE_STOP) {
        this.$emit("stopAct");
      } else if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else if (this.lessonState == storeConstants.LESSON_STATE_RESTART) {
        if (this.isShowPinchIn) {
          this.isShowPinchIn = false;
          return;
        }
        if (!this.dispAllAnswerStatus) {
          this.question();
        }
      }
      // 表示領域自動調整
      let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    },
    /**
     * 中国語表示切り替え
     * @param string newstatus
     */
    scriptType: function(newstatus) {
      // 表示テキスト一覧取得
      this.setAnswersTextList();
      // 拡大表示ボタン表示
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
      // 自動調整サイズ適用
      this.applyAutoAdjustSize();
    },
    /**
     * 表示モード切り替え
     * @param string newstatus
     */
    displayMode: function(newstatus) {
      // 問題テキスト切り替え
      this.setAnswersTextList();
      // 拡大表示ボタン表示
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
      // 自動調整サイズ適用
      this.applyAutoAdjustSize();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// A1Q.vue?75b5a9ac